export const environment = {
  production: true,
  environmentName: 'staging',
  apiGatewayURL: 'https://api.staging.hero.schoolmint.com/hero-v1'
};
